import { Pipe, PipeTransform } from '@angular/core';
import { Utility } from 'src/app/core/common';
import { SharedService } from 'src/app/services/shared.service';

@Pipe({
  name: 'readable',
  pure: true
})
export class ReadablePipe implements PipeTransform {

  constructor(private sharedService: SharedService){}
  transform(value: any|any[], translations: Record<string, string>|string ): string|string[] {
    return this.sharedService.getReadable(value, translations);
  }

}
